import { render, staticRenderFns } from "./roomSelect2.vue?vue&type=template&id=23dd9758"
import script from "./roomSelect2.vue?vue&type=script&lang=js"
export * from "./roomSelect2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports